import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

// Component for advanced search with search input and state dropdown
const AdvancedSearch = ({
  searchValue,
  stateValue,
  handleSearchChange,
  handleStateChange,
  handleKeyDown,
  states,
}) => {
  return (
    <div
      className="bg-white rounded-full px-6 py-1 shadow-lg w-full"
      style={{ maxWidth: "996px" }}
    >
      <div className="flex items-center justify-between gap-6">
        <div className="w-2/3 min-w-0">
          <div className="!text-lg !font-montserrat !font-semibold text-left ml-3 -mb-3 mt-1">
            Advanced Search
          </div>
          <input
            type="text"
            placeholder="Find city, nonprofit"
            value={searchValue}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
            className="w-full border-none outline-none !text-lg !font-montserrat text-[#7C7C7C] placeholder-[#7C7C7C] bg-transparent"
          />
        </div>

        <div className="w-px bg-gray-400 h-12"></div>

        <div className="w-1/3 min-w-0">
          <label
            htmlFor="state"
            className="!text-lg !font-montserrat !font-semibold text-left"
          >
            State
          </label>
          <div className="relative">
            <select
              id="state"
              value={stateValue}
              onChange={handleStateChange}
              className="border-none outline-none shadow-none bg-transparent !text-lg !font-montserrat text-[#7C7C7C] p-0 m-0 appearance-none w-full cursor-pointer"
            >
              <option value="" className="text-gray-400">
                Select a state
              </option>
              {states.map((state) => (
                <option
                  key={state.abbreviation}
                  value={state.abbreviation}
                  className="text-black"
                >
                  {state.name}
                </option>
              ))}
            </select>
            <FontAwesomeIcon
              icon={faChevronDown}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-400 text-xs"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const SearchHeader = ({
  searchValue,
  stateValue,
  handleSearchChange,
  handleStateChange,
  handleKeyDown,
  states,
}) => {
  return (
    <div className="sm:grow flex flex-col justify-center items-center w-full !my-0 pt-40 pb-20 bg-blue">
      <h1 className="text-white !font-poppins !text-5xl !font-medium !leading-normal mb-14">
        Non-Profits
      </h1>

      <AdvancedSearch
        searchValue={searchValue}
        stateValue={stateValue}
        handleSearchChange={handleSearchChange}
        handleStateChange={handleStateChange}
        handleKeyDown={handleKeyDown}
        states={states}
      />
    </div>
  );
};

export default SearchHeader;
